import { calculateGridTemplateColumns } from 'components/DesignSystems/FilterHeader/calculateGridTemplateColumns';
import FilterCardHeader from 'components/DesignSystems/FilterHeader/FilterCardHeader';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useState } from 'react';
import { PlannedResourceRow } from 'components/IAP/hooks/assignmentListHooks';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import AssignmentCardResourceAttachmentDialog from './AssignmentCardResourceAttachmentDialog';

const AssignmentCardPlannedResourceView = ({
  plannedResource,
}: {
  plannedResource: PlannedResourceRow;
}) => {
  const gridTemplateColumns = calculateGridTemplateColumns(5);

  const [showDialog, setShowDialog] = useState(false);

  const [expanded, setExpanded] = useState(false);
  return (
    <>
      <div className="mb-2">
        <div onClick={() => setExpanded(!expanded)} role="button">
          <FilterCardHeader gridTemplateColumns={gridTemplateColumns}>
            <div>
              {!expanded ? (
                <SharedIcon iconName="keyboard_arrow_right" size="sm" />
              ) : (
                <SharedIcon iconName="keyboard_arrow_down" size="sm" />
              )}
            </div>
            <div>{plannedResource.name}</div>
            <div>{plannedResource.leader}</div>
            <div>{plannedResource.numberOfPersons}</div>
            <div>{plannedResource.contactInfo}</div>
            <div>{plannedResource.reportingInfo}</div>
            <div>
              {plannedResource.has204a && (
                <>
                  <StylishNewButton
                    className="btn-sm border border-neutral-500 bg-dark"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowDialog(true);
                    }}
                    title="View 204a details"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <SharedIcon
                        iconName="check_circle"
                        size="sm"
                        className="text-success"
                      />{' '}
                      204a
                    </div>
                  </StylishNewButton>
                </>
              )}
            </div>
          </FilterCardHeader>
        </div>
        {expanded && (
          <div
            key={plannedResource.id}
            className="mb-2 p-2 d-flex gap-2 bg-neutral-700"
          >
            <div>{`Resource Type: ${plannedResource.type}`}</div>
          </div>
        )}
      </div>
      {showDialog && (
        <AssignmentCardResourceAttachmentDialog
          onClose={() => setShowDialog(false)}
          data={plannedResource}
        />
      )}
    </>
  );
};

export default AssignmentCardPlannedResourceView;
